module.exports = __webpack_public_path__ + "assets/img/xjone.845434b4.png";